import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function Datenschutz() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#6B6B6B] hover:text-primary transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-[#1A1A1A] mb-2">Datenschutzerklärung</h1>
        <p className="text-[#6B6B6B] mb-8">Stand: April 2026</p>

        <section className="space-y-8">
          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Allgemeine Hinweise</h3>
            <p className="text-[#6B6B6B]">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
              unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Datenerfassung auf dieser Website</h3>
            <p className="text-[#6B6B6B] mb-2">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
            </p>
            <p className="text-[#6B6B6B] mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
              können Sie dem Impressum dieser Website entnehmen.
            </p>
            <p className="text-[#6B6B6B] mb-2">
              <strong>Wie erfassen wir Ihre Daten?</strong>
            </p>
            <p className="text-[#6B6B6B] mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B.
              um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach
              Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
              technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>
            <p className="text-[#6B6B6B] mb-2">
              <strong>Wofür nutzen wir Ihre Daten?</strong>
            </p>
            <p className="text-[#6B6B6B]">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten.
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">2. Hosting</h2>
            <p className="text-[#6B6B6B]">
              Wir hosten die Inhalte unserer Website bei Railway. Anbieter ist die Railway Corp, 340 S Lemon Ave
              #4133, Walnut, CA 91789, USA. Einzelheiten entnehmen Sie der Datenschutzerklärung von Railway:{' '}
              <a
                href="https://railway.app/legal/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://railway.app/legal/privacy
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Datenschutz</h3>
            <p className="text-[#6B6B6B] mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie
              dieser Datenschutzerklärung.
            </p>
            <p className="text-[#6B6B6B]">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die
              vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie
              erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Verantwortliche Stelle</h3>
            <p className="text-[#6B6B6B]">
              MAMAL GmbH<br />
              Musterstraße 1<br />
              12345 Musterstadt<br />
              E-Mail: <a href="mailto:kontakt@mamal.de" className="text-primary hover:underline">kontakt@mamal.de</a>
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Ihre Rechte</h3>
            <p className="text-[#6B6B6B] mb-2">Sie haben jederzeit das Recht:</p>
            <ul className="list-disc list-inside text-[#6B6B6B] space-y-1 ml-2">
              <li>unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)</li>
              <li>die Berichtigung oder Löschung dieser Daten zu verlangen (Art. 16, 17 DSGVO)</li>
              <li>die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
              <li>der Verarbeitung zu widersprechen (Art. 21 DSGVO)</li>
              <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
              <li>eine erteilte Einwilligung jederzeit zu widerrufen</li>
            </ul>
            <p className="text-[#6B6B6B] mt-2">
              Außerdem steht Ihnen das Recht zu, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">4. Datenerfassung auf dieser Website</h2>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Cookies</h3>
            <p className="text-[#6B6B6B]">
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf
              Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
              Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf
              Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren
              Webbrowser erfolgt.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Server-Log-Dateien</h3>
            <p className="text-[#6B6B6B]">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
              Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc list-inside text-[#6B6B6B] space-y-1 ml-2 mt-2">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="text-[#6B6B6B] mt-2">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">Kontaktformular</h3>
            <p className="text-[#6B6B6B]">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
              Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
              und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
              Einwilligung weiter. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b
              DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">5. Supabase</h2>
            <p className="text-[#6B6B6B]">
              Wir verwenden Supabase als Backend-as-a-Service für Datenbankoperationen, Authentifizierung und
              Datenspeicherung. Anbieter ist die Supabase Inc., 970 Toa Payoh North, #07-04, Singapur 318992.
              Ihre Daten werden in der EU-Region gespeichert. Weitere Informationen finden Sie in der
              Datenschutzerklärung von Supabase:{' '}
              <a
                href="https://supabase.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://supabase.com/privacy
              </a>
              .
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 flex flex-wrap gap-4 justify-center text-sm text-[#6B6B6B]">
          <Link to="/impressum" className="hover:text-primary transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-primary transition-colors font-medium">Datenschutz</Link>
          <Link to="/agb" className="hover:text-primary transition-colors">AGB</Link>
        </div>
      </footer>
    </div>
  );
}
